import React, { useState, useRef } from "react"
import { getDaysBetweenDates, getMonthsBetweenDates, getMonthDays } from '../detail/dashboard/components/utils'
import { parseTime } from "@/utils"
import { useRequest } from "ahooks";
import { PPMService, saveOverviewConfigApi } from "@/services"
import { uploadPlmFileAPI, postWorkPackageMsgAPI } from "@/services/ppm"
import { Descendant } from 'slate';

export enum k_weekType {
    oneWeek = 1,
    twoWeek = 2,
    fourWeek = 4,
    eightWeek = 8,
    sixteenWeek = 16
}
export interface WeekDate {
    weekDate: string,
    date: string,
    isToday: boolean
}
export const getFormattedWeekDates = (type: k_weekType = k_weekType.twoWeek) => {
    const today = new Date();
    const todayDateStr = parseTime(today, '{y}-{m}-{d}')
    // const dayOfWeek = today.getDay() || 7; // 将周日(0)转为7
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - Math.floor(type * 7 / 2));

    const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    const weekDates = [];

    let endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + type * 7 - 1);

    for (let i = 0; i < type * 7; i++) {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() + i);

        const day = date.getDate();
        const dayWeekName = weekDays[date.getDay()];
        const itemDateStr = parseTime(date, '{y}-{m}-{d}')

        weekDates.push({ weekDate: `${date.getMonth() + 1 + "月"}${day}日${dayWeekName}`, date: itemDateStr, isToday: itemDateStr === todayDateStr });  
    }
    let startDateStr = parseTime(startDate, '{y}年{m}月{d}日')
    let endDateStr = parseTime(endDate, '{m}月{d}日')
    return {
        weekDates,
        startDate: parseTime(startDate, '{y}-{m}-{d}'),
        endDate: parseTime(endDate, '{y}-{m}-{d}'),
        startEndLabel: `${startDateStr} - ${endDateStr}`
    }
}

export const usePlmStatuses = () => {
    const { data: statuses } = useRequest(PPMService.getStatuses, {
        cacheKey: 'PpmStatuses',
        debounceWait: 300,
    });

}
interface IMilestoneEditStatus{
    onRefreshList: () => void,
    onCancel: () => void,
}

export const k_dateWidth = 188

export type RenderProjectItem = API.PROJECT.OverviewProject & { isSelected?: boolean, milestones: API.PROJECT.OverviewMilestone[] }

export type PopProjectItem = API.PROJECT.OverviewProject & { isSelected?: boolean }

export const usePlmImageUpload = ({ workpackageID, onUploadSuccess }: { workpackageID: number | string, onUploadSuccess: (url: string)=>void }) => {
    const ref = useRef<HTMLInputElement>(null);
    const uploadImage = (file: File) => {
        if (!workpackageID) return
        let formData = new FormData()
        formData.set("file", file)
        formData.set("metadata", JSON.stringify({ "fileName": file.name }))
        uploadPlmFileAPI(workpackageID, formData).then(res => {
            if (res.id) {
                console.log(res._links.downloadLocation.href)
                onUploadSuccess("/workbenchApi" + res._links.downloadLocation.href)
            }
        })
    }
    const onImageSelectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return
        const file = e.target.files[0];
        if (!file) return;
        uploadImage(file)
        console.log(file)
    }
    return {
        ref,
        onImageSelectChange,
    }
}

export const serializeToHtml = (nodes: any[]) => {
    return nodes.map(node => {
        if (!node.type && !node.text) {
            return ""
        }
        let content = node.text || ""
        if (node.type === "image") {
            const url = node.url.replace("/workbenchApi", "")
            content += `<p class="op-uc-p"><img class="op-uc-image op-uc-image_inline" src="${url}" /></p>`
        }
        if (node.type === "mention") {
            content += `<mention class="mention" data-id="${node.userId}" data-type="user" data-text="@${node.userName}">@${node.userName}</mention>`
        }else if (node.children && node.children.length > 0) {
            content += serializeToHtml(node.children)
        }
        if (node.type === "paragraph") {
            content = `<p class="op-uc-p">${content}</p>`
        }
        console.log(node)
        return content
    }).join("")
}